// extracted by mini-css-extract-plugin
export default {"sectionTitle":"q37Xb1","heading":"XxGV9R","selectedNameSlot":"b53V5j","selectedNameBadgeSkeleton":"UP7v86","selectedNameBadgeBaselineShim":"k6DujK","selectedNameBadge":"sbftWW"};